import { useQuery } from "@tanstack/react-query";
import FETCHER from "./_fetcher";
import { IAdvertisement } from "types/advertisement";

export const getAdvertisementById = async (id: string | number) => {
  try {
    const result = await FETCHER.get<IAdvertisement>(`/advertisements/${id}`);
    return result.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const useGetAdvertisementById = (id: string | number | undefined) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["getAdvertisementById", id],
    queryFn: () => getAdvertisementById(id!),
    enabled: !!id,
    refetchInterval: 3000,
  });

  return {
    advertisement: data,
    isLoading,
    error,
  };
};
